/** Форматирование цены */
export function formatPrice(value: number): string {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value)
}

/** Склонение слова «товар» */
export function pluralizeProduct(count: number): string {
  const abs = Math.abs(count) % 100
  const lastDigit = abs % 10

  if (abs > 10 && abs < 20) return 'товаров'
  if (lastDigit > 1 && lastDigit < 5) return 'товара'
  if (lastDigit === 1) return 'товар'
  return 'товаров'
}
